export const selectCoupons = (state) => state.coupon.coupons;
export const selectCouponLoading = (state) => state.coupon.loading;
export const selectCouponError = (state) => state.coupon.error;
export const selectCouponSuccess = (state) => state.coupon.success;